<template>
  <div class="container">
    <div class="discover-content">
      <h1>宝丽来移模作品</h1>
      <p class="intro">
        用移膜技法将老照片重新呈现，保留时光的温度与质感。
      </p>

      <div class="gallery">
        <div
          v-for="(work, index) in works"
          :key="index"
          class="gallery-item"
          @click="openLightbox(index)"
        >
          <img :src="work.src" :alt="work.title" />
          <div class="work-title">{{ work.title }}</div>
        </div>
      </div>

      <!-- Lightbox -->
      <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
        <button class="lightbox-close" @click="closeLightbox">&times;</button>
        <button class="lightbox-prev" @click.stop="prevImage">&lt;</button>
        <img :src="works[lightboxIndex].src" :alt="works[lightboxIndex].title" />
        <div class="lightbox-info">{{ works[lightboxIndex].title }}</div>
        <button class="lightbox-next" @click.stop="nextImage">&gt;</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiscoverPage",
  data() {
    return {
      // 作品配置 - 在此添加/修改作品
      // 本地图片: src: '/images/polaroid/文件名'
      // 外部URL: src: 'https://cdn.example.com/图片.jpg'
      works: [
        { src: "/images/polaroid/1.jpg", title: "作品 1" },
        { src: "/images/polaroid/2.jpg", title: "作品 2" },
        { src: "/images/polaroid/3.jpg", title: "作品 3" },
        { src: "/images/polaroid/4.jpg", title: "作品 4" },
        { src: "/images/polaroid/5.jpg", title: "作品 5" },
        { src: "/images/polaroid/6.jpg", title: "作品 6" },
        { src: "/images/polaroid/7.jpg", title: "作品 7" },
        { src: "/images/polaroid/8.jpg", title: "作品 8" },
        { src: "/images/polaroid/9.jpg", title: "作品 9" },
        { src: "/images/polaroid/10.jpg", title: "作品 10" },
      ],
      lightboxVisible: false,
      lightboxIndex: 0,
    };
  },
  methods: {
    openLightbox(index) {
      this.lightboxIndex = index;
      this.lightboxVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeLightbox() {
      this.lightboxVisible = false;
      document.body.style.overflow = "";
    },
    prevImage() {
      this.lightboxIndex =
        (this.lightboxIndex - 1 + this.works.length) % this.works.length;
    },
    nextImage() {
      this.lightboxIndex = (this.lightboxIndex + 1) % this.works.length;
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  background: rgba(253, 246, 233, 0.85);
  overflow-y: auto;
  height: 80vh;
  padding: 20px;
  color: #5a4a3a;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.container::-webkit-scrollbar {
  display: none;
}

.discover-content {
  max-width: 1200px;
  margin: 0 auto;
}

.discover-content h1 {
  font-size: 2.5em;
  margin-bottom: 15px;
  color: #8b6914;
  text-align: center;
}

.intro {
  font-size: 1.1em;
  text-align: center;
  margin-bottom: 40px;
  color: #7a6a5a;
  line-height: 1.8;
}

/* 网格画廊 */
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.gallery-item {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
  box-shadow: 0 4px 15px rgba(139, 105, 20, 0.15);
}

.gallery-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 40px rgba(139, 105, 20, 0.25);
}

.gallery-item img {
  width: 100%;
  height: 250px;
  object-fit: cover;
  display: block;
}

.work-title {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: linear-gradient(transparent, rgba(90, 74, 58, 0.85));
  color: #fdf6e9;
  font-size: 0.95em;
  text-align: center;
}

/* Lightbox */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(253, 246, 233, 0.98);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.lightbox img {
  max-width: 90%;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(139, 105, 20, 0.3);
}

.lightbox-info {
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  color: #5a4a3a;
  font-size: 1.2em;
  text-shadow: 0 1px 3px rgba(255, 255, 255, 0.8);
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 30px;
  background: none;
  border: none;
  color: #5a4a3a;
  font-size: 40px;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.lightbox-close:hover {
  opacity: 1;
}

.lightbox-prev,
.lightbox-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(212, 165, 116, 0.2);
  border: none;
  color: #5a4a3a;
  font-size: 30px;
  padding: 15px 20px;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.3s;
}

.lightbox-prev {
  left: 30px;
}

.lightbox-next {
  right: 30px;
}

.lightbox-prev:hover,
.lightbox-next:hover {
  background: rgba(212, 165, 116, 0.4);
}

@media (max-width: 768px) {
  .discover-content h1 {
    font-size: 2em;
  }

  .gallery {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }

  .gallery-item img {
    height: 180px;
  }

  .lightbox-prev {
    left: 10px;
    padding: 10px 15px;
  }

  .lightbox-next {
    right: 10px;
    padding: 10px 15px;
  }
}
</style>
